import { API_EMAIL_REMINDER_CONFIG_PREFIX } from "config/api-consts";
import { BASE_API_URL } from "config/consts";
import { httpConfig } from "config/http";
import kebabCase from "lodash/kebabCase";
import {
  EmailRemindConfig,
  EmailRemindConfigFilter,
} from "models/EmailRemindConfig";
import { Repository } from "react3l-common";
import { Observable } from "rxjs";
import nameof from "ts-nameof.macro";

export type KeyType = string | number;

export class EmailRemindConfigRepository extends Repository {
  constructor() {
    super(httpConfig);
    this.baseURL = new URL(API_EMAIL_REMINDER_CONFIG_PREFIX, BASE_API_URL).href;
  }

  private mapFilterPayload = (filter?: EmailRemindConfigFilter): any => {
    if (!filter) return filter;
    const { applyFunctionId, applyFunctionValue, ...rest } = filter as any;
    return applyFunctionValue
      ? { ...rest, applyFunction: applyFunctionValue.code }
      : rest;
  };

  public count = (
    EmailRemindConfigFilter?: EmailRemindConfigFilter
  ): Observable<number> => {
    return this.http
      .post<number>(
        kebabCase(nameof(this.count)),
        this.mapFilterPayload(EmailRemindConfigFilter)
      )
      .pipe(Repository.responseDataMapper<number>());
  };

  public list = (
    EmailRemindConfigFilter?: EmailRemindConfigFilter
  ): Observable<EmailRemindConfig[]> => {
    return this.http
      .post<EmailRemindConfig[]>(
        kebabCase(nameof(this.list)),
        this.mapFilterPayload(EmailRemindConfigFilter)
      )
      .pipe(Repository.responseMapToList<EmailRemindConfig>(EmailRemindConfig));
  };

  public get = (id: number): Observable<EmailRemindConfig> => {
    return this.http
      .post<EmailRemindConfig>(kebabCase(nameof(this.get)), { id })
      .pipe(
        Repository.responseMapToModel<EmailRemindConfig>(EmailRemindConfig)
      );
  };
  public create = (
    emailRemindConfig: EmailRemindConfig
  ): Observable<EmailRemindConfig> => {
    return this.http
      .post<EmailRemindConfig>(
        kebabCase(nameof(this.create)),
        emailRemindConfig
      )
      .pipe(
        Repository.responseMapToModel<EmailRemindConfig>(EmailRemindConfig)
      );
  };

  public update = (
    emailRemindConfig: EmailRemindConfig
  ): Observable<EmailRemindConfig> => {
    return this.http
      .post<EmailRemindConfig>(
        kebabCase(nameof(this.update)),
        emailRemindConfig
      )
      .pipe(
        Repository.responseMapToModel<EmailRemindConfig>(EmailRemindConfig)
      );
  };
  public save = (
    emailRemindConfig: EmailRemindConfig
  ): Observable<EmailRemindConfig> => {
    return emailRemindConfig.id
      ? this.update(emailRemindConfig)
      : this.create(emailRemindConfig);
  };
  public delete = (
    emailRemindConfig: EmailRemindConfig
  ): Observable<EmailRemindConfig> => {
    return this.http
      .post<EmailRemindConfig>(
        kebabCase(nameof(this.delete)),
        emailRemindConfig
      )
      .pipe(
        Repository.responseMapToModel<EmailRemindConfig>(EmailRemindConfig)
      );
  };

  public bulkDelete = (idList: KeyType[]): Observable<void> => {
    return this.http
      .post(kebabCase(nameof(this.bulkDelete)), idList)
      .pipe(Repository.responseDataMapper());
  };
  public filter = (
    emailRemindConfigFilter?: EmailRemindConfigFilter
  ): Observable<EmailRemindConfig[]> => {
    return this.http
      .post<EmailRemindConfig[]>(
        kebabCase(nameof(this.filter)),
        emailRemindConfigFilter
      )
      .pipe(Repository.responseMapToList<EmailRemindConfig>(EmailRemindConfig));
  };
}

export const emailRemindConfigRepository = new EmailRemindConfigRepository();
